<mat-dialog-content>
 <div style="padding: 20px 15px 15px 15px; white-space: pre-line;">{{ data.question }}</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="onConfirm()">Yes</button>
  <button mat-button (click)="onCancel()" cdkFocusInitial>No</button>
</mat-dialog-actions>